/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from '../runtime';
/**
 * 
 * @export
 * @interface SwapScreenerLeadResidentsRequest
 */
export interface SwapScreenerLeadResidentsRequest {
    /**
     * ID of the first lead
     */
    lead_id_1: string;
    /**
     * ID of the second lead
     */
    lead_id_2: string;
    /**
     * A date when the swap should take effect. Must be today or in the past, and after both leads' current move-in dates.
     */
    swap_date: Date;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidentsRequest interface.
 */
export function instanceOfSwapScreenerLeadResidentsRequest(value: object): value is SwapScreenerLeadResidentsRequest {
    if (!('lead_id_1' in value) || value['lead_id_1'] === undefined) return false;
    if (!('lead_id_2' in value) || value['lead_id_2'] === undefined) return false;
    if (!('swap_date' in value) || value['swap_date'] === undefined) return false;
    return true;
}

export function SwapScreenerLeadResidentsRequestFromJSON(json: any): SwapScreenerLeadResidentsRequest {
    return SwapScreenerLeadResidentsRequestFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidentsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'lead_id_1': json['lead_id_1'],
        'lead_id_2': json['lead_id_2'],
        'swap_date': (json['swap_date'] == null ? json['swap_date'] : parseDate(json['swap_date'])),
    };
}

export function SwapScreenerLeadResidentsRequestToJSON(json: any): SwapScreenerLeadResidentsRequest {
    return SwapScreenerLeadResidentsRequestToJSONTyped(json, false);
}

export function SwapScreenerLeadResidentsRequestToJSONTyped(value?: SwapScreenerLeadResidentsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'lead_id_1': value['lead_id_1'],
        'lead_id_2': value['lead_id_2'],
        'swap_date': value['swap_date'] == null ? value['swap_date'] : serializeDate(value['swap_date']),
    };
}

